import Vue from 'vue'

export default function (router) {
  Vue.swal({
    title: '<div style="color:#ed7d3e;">CND RFB/PGFN</div>',
    html: `
          <div style="color:rgb(25, 48, 81); font-size: 18px;">
            <br>
            Olá!
            <br>
            A Receita Federal atualizou recentemente seu sistema, e com isso passou a exigir a <b>data de nascimento</b> do titular do CPF para a emissão da certidão RFB/PGFN.
            <br><br>
            Dessa forma, informamos que não será possível retornar a certidão para CPFs que não possuam a data de nascimento cadastrada.
            <br>
            Para que a certidão seja emitida corretamente, é necessário garantir que essa informação esteja preenchida no cadastro da empresa/pessoa.
            <br><br>
            Atualize seus dados e garanta sua informação correta.
            <br><br><br>
            <b>Atenciosamente, Equipe Monitor Contábil</b>
            </div>
    `,
    icon: 'warning',
    iconColor: '#ed7d3e',
    confirmButtonText: 'OK',
    denyButtonText: 'Atualizar dados',
    showDenyButton: true,
    buttonsStyling: false,
    width: '30%',
    customClass: {
      popup: 'swal-m',
      confirmButton: 'btn btn-primary mt-2',
      denyButton: 'btn btn-warning ml-2 mt-2',
    },
  }).then(result => {
    if (result.isDenied) {
      router.push({ name: 'empresa-view', query: { filtroRapido: 'ApenasCPF' } })
    }
  })
}
